import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import PageLoader from '../components/PageLoader';

const HomePage = React.lazy(() => import('../components/HomePage'));
const AboutMe = React.lazy(() => import('../components/Aboutme'));
const Projects = React.lazy(() => import('../components/Projects'));
const Contact = React.lazy(() => import('../components/Contact'));
const Resume = React.lazy(() => import('../components/Resume'));
const Reference = React.lazy(() => import('../components/Reference'));
const AddReference = React.lazy(() => import('../components/References'));
const News = React.lazy(() => import('../components/News'));
const GitHubProjects = React.lazy(() => import('../components/GitHubProjects'));
const EditReference = React.lazy(() => import('../components/EditReference'));
const WeatherPage = React.lazy(() => import('../components/WeatherSection'));
const SkillsPage = React.lazy(() => import('../components/skills'));
const Blogs = React.lazy(() => import('../components/Blogs'));
const UnderConstruction = React.lazy(() => import('../components/UnderConstruction'));
const Services = React.lazy(() => import('../components/services'));
const Reviews = React.lazy(() => import('../components/reviews'));

const AppRoutes = ({ guestName, handleLogout, handleGuestAccessGranted }) => (
  <Suspense fallback={<PageLoader />}>
    <Routes>
      <Route 
        path="/" 
        element={<HomePage guestName={guestName} onLogout={handleLogout} onGuestAccessGranted={handleGuestAccessGranted} />} 
      />
      <Route path="/about" element={<AboutMe user={guestName} onLogout={handleLogout} />} />
      <Route path="/projects" element={<Projects user={guestName} onLogout={handleLogout} />} />
      <Route path="/github-projects" element={<GitHubProjects user={guestName} onLogout={handleLogout} />} />
      <Route path="/contact" element={<Contact user={guestName} onLogout={handleLogout} />} />
      <Route path="/resume" element={<Resume user={guestName} onLogout={handleLogout} />} />
      <Route path="/references" element={<Reference />} />
      <Route path="/add-references" element={<AddReference user={guestName} onLogout={handleLogout} />} />
      <Route path="/edit-reference/:id" element={<EditReference />} />
      <Route path="/news" element={<News />} />
      <Route path="/services" element={<Services />} />
      <Route path="/reviews" element={<Reviews />} />
      <Route path="/weather" element={<WeatherPage />} />
      <Route path="/skills" element={<SkillsPage />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/uc" element={<UnderConstruction />} />
    </Routes>
  </Suspense>
);

export default AppRoutes;
